import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#000000',
        secondary: colors.yellow.darken2,
        accent: colors.yellow.accent3,
        error: colors.red.accent3,
      }
    },
  },
});